import Swiper from 'swiper/bundle'

/**
 * TreatmentVideos functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class VideosModule {
  /**
   * Constructs a new VideosModule instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperButtonPrev = this.element.querySelector(
      '[data-component="slider-prev-btn"]'
    )
    this.swiperButtonNext = this.element.querySelector(
      '[data-component="slider-next-btn"]'
    )
    this.swiperSlides = this.element.queryAll('.swiper-slide')

    const videos = this.element.querySelectorAll('video')

    if (this.swiperSlides.length == 1) {
      this.element.classList.add('has-single-video')
      const videosSlider = new Swiper(this.swiperElement, {
        loop: false,
        slidesPerView: 1,
        centeredSlides: false,
      })
    } else {
      const videosSlider = new Swiper(this.swiperElement, {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 30,
        autoHeight: true,
        navigation: {
          nextEl: this.swiperButtonNext,
          prevEl: this.swiperButtonPrev,
        },
      })

      videosSlider.on('slideChangeTransitionEnd', function () {
        let index_currentSlide = videosSlider.realIndex
        let currentSlide = videosSlider.slides[index_currentSlide]
        let currentSlideVideo = currentSlide.querySelector('video')
        videos.forEach((video) => {
          video.pause()
          video.currentTime = 0
        })
      })

      function stopAllVideos(videos) {
        videos.forEach((video) => {
          video.pause()
          video.currentTime = 0
        })
      }
    }
  }
}
